import axios, { parseCursor } from '@/base/api/axios'

export default {
  async create (data) {
    return (await axios.post('/api/applications/', data)).data
  },

  async get (applicationId) {
    return (await axios.get(`/api/applications/${applicationId}/`)).data
  },

  async list (filter) {
    const response = (await axios.get('/api/applications/', { params: filter })).data
    return {
      ...response,
      next: parseCursor(response.next),
      results: response.results,
    }
  },

  async accept (applicationId) {
    return (await axios.post(`/api/applications/${applicationId}/accept/`)).data
  },

  async decline (applicationId) {
    return (await axios.post(`/api/applications/${applicationId}/decline/`)).data
  },

  async withdraw (applicationId) {
    return (await axios.post(`/api/applications/${applicationId}/withdraw/`)).data
  },

  async conversation (activityId) {
    return (await axios.get(`/api/applications/${activityId}/conversation/`)).data
  },
}
